<template>
<div>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h2 class="card-title d-flex">{{$t('NEWSLETTER.HEADER.TITEL')}}
          <div class="ml-auto text-right">
            <vs-button  @click="LoadData()" size="small" color="primary" type="filled" icon="refresh"></vs-button>
          </div>
        </h2>
        <p class="card-subtitle">
          <span>{{$t('NEWSLETTER.HEADER.TEXT')}}</span>
        </p>
      </vs-card>
    </vs-col>
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
      <vs-card >
        <AddNewsletterDlg ref="addNewsletterDlg" v-on:Success="LoadData"></AddNewsletterDlg>
        <AddNewsletterReclistDlg ref="addNewsletterReclistDlg" v-on:Success="LoadData"></AddNewsletterReclistDlg>
        <vs-popup fullscreen :title="prevTitle" :active.sync="previewActive">
          <div v-html="prev"></div>
        </vs-popup>
        <vs-tabs >
          <vs-tab :label="$t('NEWSLETTER.TAB.LETTER')">
              <div class="d-flex align-items-center">
                <vs-button class="mt-3 mb-2"  type="filled" icon="add" @click="AddNewsletter">{{$t('NEWSLETTER.ADD')}}</vs-button>
              </div> 
              <div id="newsletter_table" class="vs-con-loading__container" >
                <vs-table
                  search
                  :data="newsletter"
                  :noDataText="$t('NEWSLETTER.NO_DATA')"
                  stripe
                  max-items="25" 
                  pagination
                  hoverFlat>

                  <template slot="header">
                    <h3>
                      {{$t('NEWSLETTER.TABLE.HEADER')}}
                    </h3>
                  </template>
                  <template slot="thead">                               
                    <vs-th sort-key="name">
                      {{$t('NEWSLETTER.TABLE.COL1')}}
                    </vs-th>
                    <vs-th sort-key="subject">
                      {{$t('NEWSLETTER.TABLE.COL2')}}
                    </vs-th>
                    <vs-th sort-key="rec_list_fk">
                      {{$t('NEWSLETTER.TABLE.COL3')}}
                    </vs-th>  
                    <vs-th sort-key="template_fk">
                      {{$t('NEWSLETTER.TABLE.COL4')}}
                    </vs-th>  
                    <vs-th sort-key="sent">
                      {{$t('NEWSLETTER.TABLE.COL5')}}
                    </vs-th>
                    <vs-th sort-key="sent_timestamp">
                      {{$t('NEWSLETTER.TABLE.COL6')}}
                    </vs-th>                                                                                                          
                    <vs-th></vs-th>                                                                                                                                             
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr"  :key="indextr" v-for="(tr, indextr) in data" >   
                      <vs-td :data="tr.name">
                        {{tr.name}}
                      </vs-td>                  
                      <vs-td :data="tr.subject">
                        {{LimitTextTo(tr.subject,150)}}
                      </vs-td>     
                      <vs-td :data="tr.rec_list_fk">
                        {{GetNameOfRecList(tr.rec_list_fk)}}
                      </vs-td> 
                      <vs-td :data="tr.template_fk">
                        {{GetNameOfTemplate(tr.template_fk)}}
                      </vs-td>   
                      <vs-td :data="tr.sent">
                        <vs-checkbox :disabled="true" v-model="tr.sent"></vs-checkbox>
                      </vs-td> 
                      <vs-td :data="tr.sent_timestamp">
                        {{DateToString(tr.sent_timestamp)}}
                      </vs-td>                                                                                                
                      <vs-td>
                        <vs-button  @click="EditNewsletter(tr)" class="ml-2" size="small" color="primary" type="filled" icon="edit"></vs-button>  
                        <vs-button  @click="OpenConfirmDeleteNewsletter(tr.id,tr.name)" :disabled="tr.sent" class="ml-2 mr-2" size="small" color="primary" type="filled" icon="delete"></vs-button>                        
                        <vs-button  @click="ShowPreview(tr.id, tr.name)" class="ml-3" size="small" color="gray" type="filled" icon="visibility"></vs-button>  
                        <vs-button  @click="OpenConfirmSendNewsletter(tr)" :disabled="tr.sent" class="ml-1" size="small" color="success" type="filled" icon="send"></vs-button>  
                      </vs-td>                    
                                                                                                                                                                                                
                    </vs-tr>
                  </template>
                </vs-table>
              </div>  
          </vs-tab>
          <vs-tab :label="$t('NEWSLETTER.TAB.RECLIST')">
              <div class="d-flex align-items-center">
                <vs-button class="mt-3 mb-2"  type="filled" icon="add" @click="AddNewsletterRecList">{{$t('NEWSLETTER.ADD_RECLIST')}}</vs-button>
              </div> 
              <div id="reclist_table" class="vs-con-loading__container" >
                <vs-table
                  search
                  :data="reclists"
                  :noDataText="$t('NEWSLETTER.NO_DATA')"
                  stripe
                  max-items="25" 
                  pagination
                  hoverFlat>

                  <template slot="header">
                    <h3>
                      {{$t('NEWSLETTER.RECLIST.TABLE.HEADER')}}
                    </h3>
                  </template>
                  <template slot="thead">                               
                    <vs-th sort-key="name">
                      {{$t('NEWSLETTER.RECLIST.TABLE.COL1')}}
                    </vs-th>
                    <vs-th sort-key="anz">
                      {{$t('NEWSLETTER.RECLIST.TABLE.COL2')}}
                    </vs-th>                                                                                                          
                    <vs-th></vs-th>                                                                                                                                             
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr"  :key="indextr" v-for="(tr, indextr) in data" >   
                      <vs-td :data="tr.name">
                        {{tr.name}}
                      </vs-td>                  
                      <vs-td :data="tr.anz">
                        {{tr.anz}}
                      </vs-td>                                                                                                    
                      <vs-td>
                        <vs-button  @click="EditReclist(tr)" class="ml-2" size="small" color="primary" type="filled" icon="edit"></vs-button>  
                        <vs-button  @click="OpenConfirmDeleteReclist(tr.id,tr.name)" class="ml-2" size="small" color="primary" type="filled" icon="delete"></vs-button>                        
                      </vs-td>                    
                                                                                                                                                                                                
                    </vs-tr>
                  </template>
                </vs-table>
              </div>  
          </vs-tab> 
          <vs-tab :label="$t('NEWSLETTER.TAB.TEMPLATES')">

              <div id="template_table" class="vs-con-loading__container" >
                <vs-table
                  search
                  :data="templates"
                  :noDataText="$t('NEWSLETTER.NO_DATA')"
                  stripe
                  max-items="25" 
                  pagination
                  hoverFlat>

                  <template slot="header">
                    <h3>
                      {{$t('NEWSLETTER.TEMPLATE.TABLE.HEADER')}}
                    </h3>
                  </template>
                  <template slot="thead">                               
                    <vs-th sort-key="name">
                      {{$t('NEWSLETTER.TEMPLATE.TABLE.COL1')}}
                    </vs-th>
                    <vs-th sort-key="filename">
                      {{$t('NEWSLETTER.TEMPLATE.TABLE.COL2')}}
                    </vs-th>                                                                                                          
                    <vs-th></vs-th>                                                                                                                                             
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr"  :key="indextr" v-for="(tr, indextr) in data" >   
                      <vs-td :data="tr.name">
                        {{tr.name}}
                      </vs-td>                  
                      <vs-td :data="tr.filename">
                        {{tr.filename}}
                      </vs-td>                                                                                                    
                      <vs-td>
                      
                      </vs-td>                    
                                                                                                                                                                                                
                    </vs-tr>
                  </template>
                </vs-table>
              </div>  
          </vs-tab>                    
        </vs-tabs>         
      </vs-card>
    </vs-col>
  </vs-row>

</div>
</template>

<script>

import helperMethods from '../helper/staticFuncHelper';
import enumHelper from '../helper/enumHelper';
import codeHelper from '../helper/staticCodeHelper';
import AddNewsletterDlg from '../views/components/dialogs/AddNewsletterDlg.vue';
import AddNewsletterReclistDlg from '../views/components/dialogs/AddNewsletterReclistDlg.vue';

export default {
  name: "Newsletters",
  components: {

    AddNewsletterDlg,
    AddNewsletterReclistDlg
  },
    data: function (){
      return {
      editorContent:"",
      newsletter:[],
      reclists:[],
      templates:[],
      prev:"",
      previewActive:false,
      prevTitle:""
      };
  },
  mounted () {
      this.LoadData();
    },
  computed: 
  { 
    getTableData() {
      var data = [];
      if(this.$store.state.newsletter.newsletter.data != null)
      {
        data = this.$store.state.newsletter.newsletter.data
      }
      return data;
    },
    getTableDataReclist() {
      var data = [];
      if(this.$store.state.newsletter.reclists.data != null)
      {
        data = this.$store.state.newsletter.reclists.data
      }
      return data;
    },
    getTableDataTemplates() {
      var data = [];
      if(this.$store.state.newsletter.templates.data != null)
      {
        data = this.$store.state.newsletter.templates.data
      }
      return data;
    },    
    loadingTableData () {
      var loading = false;
      if(typeof(this.$store.state.newsletter.newsletter.status) != 'undefined')
        loading = this.$store.state.newsletter.newsletter.status.loading;
      return loading;
    },
    loadingTableDataReclist () {
      var loading = false;
      if(typeof(this.$store.state.newsletter.reclists.status) != 'undefined')
        loading = this.$store.state.newsletter.reclists.status.loading;
      return loading;
    },
    loadingTableDataTemplates () {
      var loading = false;
      if(typeof(this.$store.state.newsletter.templates.status) != 'undefined')
        loading = this.$store.state.newsletter.templates.status.loading;
      return loading;
    },
  },
  watch: {
      getTableData(value) {
          this.newsletter = value;
      },
      previewActive(value)
      {
        if(value === false)
        {
          this.prev = "";
          this.prevTitle = "";
        }
      },
      loadingTableData(value)
      {
        if(value)
        {
          this.$store.dispatch('alertqueue/showLoader', {'id':'#newsletter_table'});
        }
        else
        {
          this.$store.dispatch('alertqueue/hideLoader', {'id':'#newsletter_table'});
        }
      },
      getTableDataReclist(value) {
          this.reclists = value;
      },
      loadingTableDataReclist(value)
      {
        if(value)
        {
          this.$store.dispatch('alertqueue/showLoader', {'id':'#reclist_table'});
        }
        else
        {
          this.$store.dispatch('alertqueue/hideLoader', {'id':'#reclist_table'});
        }
      },  
      getTableDataTemplates(value) {
          this.templates = value;
      },
      loadingTableDataTemplates(value)
      {
        if(value)
        {
          this.$store.dispatch('alertqueue/showLoader', {'id':'#template_table'});
        }
        else
        {
          this.$store.dispatch('alertqueue/hideLoader', {'id':'#template_table'});
        }
      },          
    },
  methods: {    
      ...helperMethods,
      ...enumHelper,
      ...codeHelper,
      LoadData: function ()
      {
          this.$store.dispatch('newsletter/getAllNewsletter'); 
          this.$store.dispatch('newsletter/getAllReclists'); 
          this.$store.dispatch('newsletter/getAllTemplates'); 
          this.$store.dispatch('newsletter/getRecUserData'); 
      },
      EditNewsletter(data){
        this.$refs.addNewsletterDlg.InitDlgData(data);
      },
      EditReclist(data){
        this.$refs.addNewsletterReclistDlg.InitDlgData(data);
      }, 
      ShowPreview(id, name)
      {
        this.$store.dispatch('newsletter/getNewsletterPrev', id)
        .then(response => {
          if(response.success == true)
          {
            this.prev = response.text;
            this.prevTitle = name;
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('NEWSLETTER.SUCCESS.PREVIEW').replace("*1*",name)});  
            this.previewActive = true;
          }
          else
          {
            var text = this.$t('NEWSLETTER.WARNING.PREVIEW').replace("*1*",name);
            text = text.replace("*2*",this.$t(response.text));
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
          }
        }, 
        error =>{

            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('NEWSLETTER.ERROR.PREVIEW').replace("*1*",error)});  
        });        
      },     
      AddNewsletter(){
        this.$refs.addNewsletterDlg.ShowDlg();
      },
      AddNewsletterRecList(){
        this.$refs.addNewsletterReclistDlg.ShowDlg();
      }, 
      AddNewsletterTemplate(){
        this.$refs.addNewsletterReclistDlg.ShowDlg();
      },            
      GetNameOfRecList(id){
        let name = "";
        if(this.$store.state.newsletter.reclists.data != null)
        {
          for (let i = 0; i < this.$store.state.newsletter.reclists.data.length; i++) {
            const element = this.$store.state.newsletter.reclists.data[i];
            if(element.id == id)
            {
              name = element.name;
              break;
            }
          }
        }
        return name;
      }   ,
      GetNameOfTemplate(id)
      {
        let name = "";
        if(this.$store.state.newsletter.templates.data != null)
        {
          for (let i = 0; i < this.$store.state.newsletter.templates.data.length; i++) {
            const element = this.$store.state.newsletter.templates.data[i];
            if(element.id == id)
            {
              name = element.name;
              break;
            }
          }
        }
        return name;
      },
      OpenConfirmDeleteReclist(id,name) {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: this.$t('COM.SURE.TITEL'),
          acceptText: this.$t('COM.DELETE'),
          cancelText:this.$t('COM.CANCEL'),
          text: this.$t('NEWSLETTER.QUESTION.DELETE_RECLIST').replace("*1*",name),
          accept: this.SendDeleteReclistRequest,
          parameters:{"id": id,"name": name}
        });
      
      },
      OpenConfirmDeleteNewsletter(id,name) {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: this.$t('COM.SURE.TITEL'),
          acceptText: this.$t('COM.DELETE'),
          cancelText:this.$t('COM.CANCEL'),
          text: this.$t('NEWSLETTER.QUESTION.DELETE_NEWSLETTER').replace("*1*",name),
          accept: this.SendDeleteNewsletterRequest,
          parameters:{"id": id,"name": name}
        });
      
      },   
      OpenConfirmSendNewsletter(data) {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: this.$t('COM.SURE.TITEL'),
          acceptText: this.$t('COM.SEND'),
          cancelText:this.$t('COM.CANCEL'),
          text: this.$t('NEWSLETTER.QUESTION.SEND_NEWSLETTER').replace("*1*",data.name),
          accept: this.SendSendNewsletterRequest,
          parameters:{"data": data}
        });
      
      },  
      SendDeleteReclistRequest: function(parameters)
      {
        this.$store.dispatch('newsletter/deleteReclist', parameters.id)
        .then(response => {
          if(response.success == true)
          {
            this.LoadData();
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('NEWSLETTER.SUCCESS.DELETE_RECLIST').replace("*1*",parameters.name)});  
          }
          else
          {
            var text = this.$t('NEWSLETTER.WARNING.DELETE_RECLIST').replace("*1*",parameters.name);
            text = text.replace("*2*",this.$t(response.text));
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
          }
        }, 
        error =>{

            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('NEWSLETTER.ERROR.DELETE_RECLIST').replace("*1*",error)});  
        });
      },
      SendDeleteNewsletterRequest: function(parameters)
      {
        this.$store.dispatch('newsletter/deleteNewsletter', parameters.id)
        .then(response => {
          if(response.success == true)
          {
            this.LoadData();
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('NEWSLETTER.SUCCESS.DELETE_NEWSLETTER').replace("*1*",parameters.name)});  
          }
          else
          {
            var text = this.$t('NEWSLETTER.WARNING.DELETE_NEWSLETTER').replace("*1*",parameters.name);
            text = text.replace("*2*",this.$t(response.text));
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
          }
        }, 
        error =>{

            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('NEWSLETTER.ERROR.DELETE_NEWSLETTER').replace("*1*",error)});  
        });
      },
      SendSendNewsletterRequest: function(parameters)
      {
        parameters.data.sendNewsletter = true;
        this.$store.dispatch('newsletter/saveNewsletter', parameters.data)
        .then(response => {
          if(response.success == true)
          {
            this.LoadData();
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('NEWSLETTER.SUCCESS.SEND_NEWSLETTER').replace("*1*",parameters.data.name)});  
          }
          else
          {
            var text = this.$t('NEWSLETTER.WARNING.SEND_NEWSLETTER').replace("*1*",parameters.data.name);
            text = text.replace("*2*",this.$t(response.text));
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
          }
        }, 
        error =>{

            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('NEWSLETTER.ERROR.SEND_NEWSLETTER').replace("*1*",error)});  
        });
      }
  }
};

</script>